import Footer from '../Home/Footer';
import SubscriptionPlan from '../SubscriptionPlans/SubscriptionPlan';
import Hero from './Hero';
import './Home.scss';
import HomeBest from './HomeBest';
import HomeCourse from './HomeCourse';
import HomeFaq from './HomeFaq';
// import HomePlans from './HomePlans';
import HomeSyllabus from './HomeSyllabus';

const TrainingApps = () => (
	<div className="home-wrapper">
		<Hero />
		<HomeBest />
		{/* <HomePlans /> */}
		<SubscriptionPlan />
		<HomeSyllabus />
		<HomeCourse />
		<HomeFaq />
		<Footer />
	</div>
);

export default TrainingApps;
